import UpdateBorrowerContent from "../../content/borrower/updateBorrower";
import { Layout } from "../../layout/page";

export function UpdatedBorrower() {
  return (
    <Layout>
      <UpdateBorrowerContent />
    </Layout>
  );
}
